<template>
	<div class="comp-record-search">
		<div class="comp-record-search-title">
			<span class="comp-record-st-name">搜聊天记录</span>
			<span class="comp-record-st-close" @click="closeOrder">关闭</span>
		</div>
		<div class="comp-record-ss">
			<div class="comp-record-ss-wrap">
				<div class="comp-record-ss-icon"></div>
				<input type="text" v-model="keyword">
				<div class="comp-record-ss-clear" @click="clearSearch"></div>
			</div>
		</div>
		<div class="comp-record-sd-box" v-show="fansCount > 0">
			<!-- 列表页面 -->
			<chat-recod-search-fans-comp 
				:keyword="keyword" 
				@chat-record-search-fans-call="fansCall($event)" 
				ref="searchFans">
			</chat-recod-search-fans-comp>
			<!-- 搜索结果页面 -->
			<chat-recod-search-content-comp 
				:fans="fans" 
				:keyword="keyword" 
				@chat-click="chatClick($event)" 
				@record-click="recordClick($event)" 
				v-show="recordId == 0">
			</chat-recod-search-content-comp>
			<!-- 上下文页面 -->
			<chat-recod-search-detail-comp 
				:fans="fans" :keyword="keyword" 
				:recordId="recordId"
				@go-back="recordId = 0"
				v-show="recordId > 0">
			</chat-recod-search-detail-comp>
		</div>
		<div class="comp-record-sd-box" v-show="fansCount == 0">
			<div class="comp-record-sd-empty"></div>
			<p class="comp-record-sd-empty-p">提示：关键词为空或搜索结果为空！</p>
		</div>
	</div>
</template>

<script>
	import ChatRecodSearchFansComp from './ChatRecodSearchFansComp.vue'
	import ChatRecodSearchContentComp from './ChatRecodSearchContentComp.vue'
	import ChatRecodSearchDetailComp from './ChatRecodSearchDetailComp.vue'
	
	export default{
		name:"ChatRecodSearchComp",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			},
			sKeyword:{
				  type: String,
				  default: ''
			}
		},
		components:{
			ChatRecodSearchFansComp,
			ChatRecodSearchContentComp,
			ChatRecodSearchDetailComp
		},
		data(){
			return {
				keyword: '',
				fansCount: 0,
				fans:{},
				recordId: 0
			}
		},
		methods:{
			init(){
				this.keyword = ''
				this.fansCount = 0
				this.fans = {}
				this.recordId = 0
			},
			
			// 关闭页面
			closeOrder(){
				this.$emit('record-search-close')
			},
			
			// 搜索粉丝和群后的回调
			fansCall(data){
				this.recordId = 0
				if(data.type === 'count'){
					this.fansCount = parseInt(data.num)
					this.fans = {}
				}else if(data.type === 'fans'){
					this.fans = data.fans
				}
			},
			
			// 清空搜索
			clearSearch(){
				this.init()
			},
			
			// 主动触发搜索
			autoSearch(){
				let keywords = this.sKeyword.split('------')
				if(keywords.length === 2){
					this.keyword = keywords[0]
					this.$refs.searchFans.getList(this.keyword)
				}else{
					this.keyword = ''
				}
			},
			
			// 进入聊天回调
			chatClick(data){
				this.$emit('chat-click',data)
			},
			
			// 查看上下文点击回调
			recordClick(data){
				this.recordId = parseInt(data)
			}
		},
		mounted() {
			this.autoSearch()
		},
		watch:{
			sKeyword(nVal){
				this.autoSearch()
			}
		}
	}
</script>

<style>
	.comp-record-search{
		position: absolute;
		top: 120px;
		left: 40px;
		bottom: 120px;
		right: 40px;
		background-color: #FFFFFF;
		z-index: 11;
	}
	.comp-record-search-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.comp-record-st-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.comp-record-ss{
		height: 28px;
		padding: 10px;
	}
	.comp-record-ss .comp-record-ss-wrap{
		width: 80%;
		height: 28px;
		max-width: 500px;
		margin: 0 auto;
		position: relative;
	}
	.comp-record-ss-wrap .comp-record-ss-icon{
		width: 26px;
		height: 26px;
		background-image: url(../../assets/img/c-all-search.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
		position: absolute;
		top: 1px;
		left: 1px;
	}
	.comp-record-ss-wrap input{
		border: 1px solid #e4e4e4;
		display: block;
		width: 100%;
		height: 28px;
		line-height: 28px;
		padding: 0 26px;
		box-sizing: border-box;
		border-radius: 4px;
		color: #999999;
	}
	.comp-record-ss-wrap input:focus{
		border: 1px solid #42B983;
	}
	.comp-record-ss-wrap .comp-record-ss-clear{
		width: 26px;
		height: 26px;
		background-image: url(../../assets/img/comp-close.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
		position: absolute;
		top: 1px;
		right: 1px;
		cursor: pointer;
	}
	.comp-record-sd-box{
		position: absolute;
		top: 80px;
		bottom: 0;
		left: 0;
		right: 0;
		overflow: hidden;
		border-top: 1px solid #e4e4e4;
	}
	.comp-record-sd-empty{
		width: 100px;
		height: 100px;
		margin: 0 auto;
		margin-top: 50px;
		background-image: url(../../assets/img/chat-big.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.comp-record-sd-empty-p{
		text-align: center;
		color: #999999;
		margin-top: 20px;
	}
</style>
